module.exports = __webpack_public_path__ + "media/Nao, estou nao.6ca7ac12.mp3";